import { IBannerDetailsMediaComponent } from "../banners/media/banner-details-media.component";
import { BannerDetailsMediaFactory } from "../banners/media/banner-details-media.factory";

export class SitesInfoBannerMediaService {
    private _currentContext = $();

    private _mediaArray: Array<IBannerDetailsMediaComponent> = [];

    private parseContext(): void {
        const mediaFactory = new BannerDetailsMediaFactory();
        const mediaFactories = $(BannerDetailsMediaFactory.MEDIA_SELECTOR, this._currentContext);
        mediaFactories.each((index, entry) => {
            const mediaFactoryContext = $(entry);
            const media = mediaFactory.getBrandDetailsMedia(mediaFactoryContext);
            this._mediaArray.push(media);
        });
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;
        this.parseContext();
    }
}
